import actionTypes from './index';

export default () => ({ type: actionTypes.COLLAPSE_ALL });
